import React from "react";
import { Route, Switch} from "react-router-dom";
import OrganizationSettings from "../OrganizationSettings";
import PageNotFound from "../../UtilityComponents/pageNotFound";

function Organizations() {
    return (
        <div className="organizations-container">
            <Switch>
                <Route path="/organizations/:organization/settings" component={OrganizationSettings}></Route>
                <Route path="/organizations" component={PageNotFound}></Route>
            </Switch>
        </div>
    )
}

export default Organizations;